// extracted by mini-css-extract-plugin
module.exports = {"parsed":"AtAGlance_parsed__AaBsT"};